import { render, staticRenderFns } from "./rule-menu.vue?vue&type=template&id=5c0d2e35&scoped=true&"
import script from "./rule-menu.vue?vue&type=script&lang=ts&"
export * from "./rule-menu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0d2e35",
  null
  
)

export default component.exports